import React, { useState } from 'react'
import AITool from '../components/AITool'
import './LearningTools.css'

const LearningTools: React.FC = () => {
  const [activeTool, setActiveTool] = useState('quiz')

  const tools = [
    {
      id: 'quiz',
      name: 'Quiz Generator',
      description: 'Create engaging quizzes and questions from any topic',
      icon: '🎯',
      endpoint: '/.netlify/functions/generate-quiz',
      fields: [
        { name: 'topic', label: 'Topic', type: 'text' as const, placeholder: 'e.g., JavaScript Fundamentals, World History' },
        { name: 'difficulty', label: 'Difficulty Level', type: 'select' as const, options: ['Beginner', 'Intermediate', 'Advanced'] },
        { name: 'questionCount', label: 'Number of Questions', type: 'select' as const, options: ['5', '10', '15', '20'] },
        { name: 'questionType', label: 'Question Type', type: 'select' as const, options: ['Multiple Choice', 'True/False', 'Short Answer', 'Mixed'] }
      ]
    },
    {
      id: 'translate',
      name: 'Language Translator',
      description: 'Translate text and fix grammar in multiple languages',
      icon: '🌐',
      endpoint: '/.netlify/functions/translate',
      fields: [
        { name: 'text', label: 'Text to Translate', type: 'textarea' as const, placeholder: 'Enter the text you want to translate' },
        { name: 'fromLanguage', label: 'From Language', type: 'select' as const, options: ['English', 'Spanish', 'French', 'German', 'Italian', 'Portuguese', 'Chinese', 'Japanese', 'Korean', 'Arabic'] },
        { name: 'toLanguage', label: 'To Language', type: 'select' as const, options: ['English', 'Spanish', 'French', 'German', 'Italian', 'Portuguese', 'Chinese', 'Japanese', 'Korean', 'Arabic'] },
        { name: 'fixGrammar', label: 'Fix Grammar', type: 'select' as const, options: ['Yes', 'No'] }
      ]
    },
    {
      id: 'essay',
      name: 'Essay Feedback',
      description: 'Get detailed feedback and scoring for your essays',
      icon: '📝',
      endpoint: '/.netlify/functions/essay-feedback',
      fields: [
        { name: 'essay', label: 'Essay Text', type: 'textarea' as const, placeholder: 'Paste your essay here for analysis' },
        { name: 'topic', label: 'Essay Topic (Optional)', type: 'text' as const, placeholder: 'e.g., Climate Change, Personal Statement' },
        { name: 'type', label: 'Essay Type', type: 'select' as const, options: ['Academic', 'Personal Statement', 'Argumentative', 'Narrative', 'Descriptive'] },
        { name: 'focus', label: 'Focus Areas', type: 'select' as const, options: ['Grammar & Style', 'Content & Structure', 'Argument & Logic', 'All Areas'] }
      ]
    }
  ]

  return (
    <div className="learning-tools">
      <div className="page-header">
        <h1>Learning Tools</h1>
        <p>Create quizzes, translate text, and get essay feedback with AI assistance</p>
      </div>

      <div className="tools-tabs">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`tab-button ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
          >
            <span className="tool-icon">{tool.icon}</span>
            <span className="tool-name">{tool.name}</span>
          </button>
        ))}
      </div>

      <div className="tool-content">
        {tools.map((tool) => (
          <div key={tool.id} className={`tool-panel ${activeTool === tool.id ? 'active' : ''}`}>
            <AITool
              title={tool.name}
              description={tool.description}
              endpoint={tool.endpoint}
              fields={tool.fields}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default LearningTools 